/*
 * Public API Surface of ngx-dynamic-tabindex
 */

export * from './lib/ngx-dynamic-tabindex.directive';
export * from './lib/ngx-dynamic-tabindex.module';
